var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PlanningAlertDetails',{attrs:{"alertId":_vm.$route.params.alert_id}})
}
var staticRenderFns = []

export { render, staticRenderFns }